import MuiAvatar, { AvatarProps as MuiAvatarProps } from "@mui/material/Avatar";
import React, { FunctionComponent } from "react";
import Text from "../text/Text";

export interface AvatarProps extends Omit<MuiAvatarProps, "children" | "variant"> {
	/** indicates if avatar represents someone outside the company */
	external?: boolean;

	/** initials of person (if no image) */
	initials?: string;
}

export const Avatar: FunctionComponent<AvatarProps> = (props) => {
	const { external, initials, ...otherProps } = props;

	return (
		<MuiAvatar
			variant={external ? "rounded" : "circular"}
			{...otherProps}
		>
			{!props.src &&
				<Text semiBold text={initials} />
			}
		</MuiAvatar>
	);
};

export default Avatar;
